import React, { useCallback, useState } from 'react'
import { SubscribeModal } from 'ppp'
import { gaEvent, themeColor } from 'shared'
import { SubscribeButtonProps } from './types'

export const SubscribeButton = ({ project, url }: SubscribeButtonProps): JSX.Element => {
  const [show, setShow] = useState(false)

  const handleClick = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_open_link__top')
    setShow(true)
  }, [])

  const onHide = useCallback(() => {
    gaEvent('engagement', 'click subscribe_newsletter_modal_close_link__top')
    setShow(false)
  }, [])

  return (
    <div className="w-full">
      <strong>
        <span>Fans:&nbsp;</span>
        {(project.id && project.newsletter_subscriptions_count) || <span>0</span>}{' '}
      </strong>
      <a onClick={handleClick} style={{ color: themeColor('green-800') }}>
        <i className="fa fa-lg fa-heart ml-1 mr-1" style={{ color: themeColor('red-500') }} />
        <span>{I18n.t('projects.show.stats.become_a_fan')}</span>
      </a>

      <SubscribeModal show={show} project={project} url={url} onHide={onHide} />
    </div>
  )
}
